export enum InvestmentType {
    INDIVIDUAL = 'INDIVIDUAL',
    EMPLOYER = 'EMPLOYER',
    HSA_FSA = 'HSA_FSA',
    BROKERAGE = 'BROKERAGE',
    COLLEGE = 'COLLEGE',
    NONE = 'NONE',
    OTHER = 'OTHER',
}
